import React, { useEffect, useState } from 'react';
import {
	Grid,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { CountryList } from '../../../../components/CountryList';

import { TagList } from '../../../../components/TagList';
import Input from 'src/components/Input';
import DateTimeInput from 'src/components/DateTimeInput';
import moment from 'moment';

const INIT_FORM_DATA = {
	title: '',
	labels: [],
	country: '',
	startDateTime: '',
	endDateTime: '',
	startsIn: '',
	isActive: true
};

const INIT_ERRORS = {
	title: '',
	labels:'',
	country: '',
	startDateTime: '',
	endDateTime: '',
	startsIn: ''
};

const AddFlashSale = ({ isVisible, onClose, onCreate, existingFormData, labels, country }) => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState({ ...INIT_FORM_DATA, country: country });
	const [selectedProductLabels, setSelectedProductLabels] = useState([]);
	const [filteredLabels, setFilteredLabels] = useState([]);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		if (existingFormData) {
			console.log("existingFormData::", existingFormData)
			// const precautions =
			// 	existingFormData && existingFormData.precautions
			// 		? convertHtmlToText(existingFormData.precautions)
			// 		: null;
			// const userGuide =
			// 	existingFormData && existingFormData.userGuide
			// 		? convertHtmlToText(existingFormData.userGuide)
			// 		: null;
			// const voucherTypeId = voucherTypes && voucherTypes.length > 0 && isUpdate? voucherTypes[0].id : null

			setFormData({ ...existingFormData,
				startDateTime : new Date(existingFormData.startDateTime).toISOString(),
				endDateTime : new Date(existingFormData.endDateTime).toISOString(),
				startsIn : new Date(existingFormData.startsIn).toISOString()
			});
			// setBackgroundImage(existingFormData.imageUrl);
		}
	}, [existingFormData]);

	useEffect(() => {
		if (!country) return;
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	}, [country]);

	useEffect(() => {
		const keys = Object.keys(errors);
		let hasValue = true;
		keys.forEach((errKey) => {
			if (formData[errKey] === '' || formData[errKey] === null) {
				hasValue = false;
			}
		});

		setHasError(!hasValue);
	}, [formData, errors]);

	useEffect(() => {
		if (selectedProductLabels && selectedProductLabels.length > 0) {
			setFilteredLabels(
				labels.filter(({ id }) => !selectedProductLabels.some((item) => item.id === id))
			);
		} else {
			setFilteredLabels([...labels]);
		}
	}, [selectedProductLabels, labels]);

	useEffect(() => {
		if (existingFormData && existingFormData.label && existingFormData.label.length > 0) {
			console.log("setSelectedProductLabels::", existingFormData.label);
			setSelectedProductLabels([...existingFormData.label]);
		}
		console.log("formData>>>", formData);
	}, [existingFormData]); // eslint-disable-line react-hooks/exhaustive-deps

	const handleCloseModal = (e) => {
		e && e.stopPropagation();
		setSelectedProductLabels([]);
		// setBackgroundImage(DEFAULT_DESIGN);
		setErrors(INIT_ERRORS);
		setFormData({ ...INIT_FORM_DATA, country });
		onClose(false);
	};

	const validateField = (name, value) => {
		if (!(name in errors)) {
			return;
		}

		setErrors((prevState) => ({
			...prevState,
			[name]: value ? '' : 'This field is required.',
		}));
	};

	const validateHasError = (name, value) => {
		if (!(name in errors)) {
			return false;
		}

		return !(value !== null && value !== '' && value !== undefined);
	};

	const handleInputChange = (event, type) => {
		const { id, value } = event.target;

		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));

		if (type === 'number') {
			setErrors((prevState) => ({
				...prevState,
				[id]: value <= 0 ? 'Only accept positive numbers' : '',
			}));
			return;
		}

		validateField(id, value);
	};

	const inputPropsHandlers = {
		onChangeBlur: handleInputChange,
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		console.log(country);
		setFormData((prevState) => ({
			...prevState,
			country,
		}));
	};

	const onCreateHandler = () => {
		const items = Object.keys({ ...formData });

		console.log("items:", items)
		let isAllFieldsValidated = true;

		items.forEach((item) => {
			validateField(item, formData[item]);
			if (validateHasError(item, formData[item])) {
				isAllFieldsValidated = false;
			}
		});

		console.log("isAllFieldsValidated", isAllFieldsValidated)

		if (isAllFieldsValidated) {
			const payload = {
				...formData,
				// image,
				isUpdate,
				// precautions: convertTextToMarkup(formData.precautions),
				// userGuide: convertTextToMarkup(formData.userGuide),
				// airAsiaData: { ...airasiaData, validTermDd: formData.validTermDd },
			};
			onCreate({ ...payload });
			handleCloseModal();
			// setImage(null);
		}
	};

	const handleSelectedOptionsChange = (selectedOptions) => {
		// setSelectedProductLabels([...selectedProductLabels, selectedOptions]); //comment this as of now allow only one label till ui support multi
		setSelectedProductLabels([...selectedOptions]);
		setFormData((prevState) => ({
			...prevState,
			label: [...selectedOptions],
		}));
	};

	const datePickerChangeHandler = (dateTimeValue) => {
		const { id, value } = dateTimeValue;
		setFormData((prevState) => ({
			...prevState,
			[id]: moment(new Date(value), '').format()
		}));
		validateField(id, value);
		console.log("formData:::", formData);
	};

	return (
		<Dialog
			open={isVisible}
			onClose={handleCloseModal}
			fullScreen={fullScreen}
			scroll="paper"
			maxWidth={'sm'}
		>
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Flash Sale
			</DialogTitle>
			<DialogContent dividers>
				<Box sx={{ flexGrow: 1 }}>
					<Grid container spacing={3} columns={12} direction="column">
						{/* <Grid item md={8} xs={8}>
							<Divider />
						</Grid> */}
						<Grid item md={7} xs={12}>
							<Box sx={{ flexGrow: 1 }}>
								<Grid container spacing={3}>
									<Grid container item md={12} xs={12}>
										<Input
											{...inputPropsHandlers}
											id="title"
											label="Title"
											value={formData.title}
											error={errors.title}
										/>
									</Grid>
									<Grid container item>
										<Grid item md={12} xs={12}>
											<TagList
												isMultiple={true}
												options={filteredLabels}
												value={formData && formData.label}
												onSelectedOptionsChange={
													handleSelectedOptionsChange
												}
											/>

											{/* <TagList
												isMultiple={true}
												options={filteredLabels}
												value={formData && formData.labels}
												onSelectedOptionsChange={
													handleSelectedOptionsChange
												}
											/> */}
										</Grid>
									</Grid>
									<Grid container item md={12} xs={12}>
										<CountryList
											disabled
											onChange={handlSelectChange}
											placeholder="Select Country"
											id="country"
											label="Country name"
											variant="filled"
											value={formData.country != null ? formData.country : ''}
											error={!!errors.title}
										/>
									</Grid>
									<Grid container item spacing={2}>
										<Grid item md={6} xs={6}>
											<DateTimeInput id="startDateTime" type="datetime" label="Start DateTime" value={formData.startDateTime || null} onChange={datePickerChangeHandler} />
										</Grid>
										<Grid item md={6} xs={6}>
											<DateTimeInput id="endDateTime" type="datetime" label="End DateTime" value={formData.endDateTime || null} onChange={datePickerChangeHandler} />
										</Grid>
									</Grid>
									<Grid container item spacing={2}>
										<Grid item md={6} xs={6}>
											<DateTimeInput id="startsIn" type="datetime" label="Starts-In DateTime" value={formData.startsIn || null} onChange={datePickerChangeHandler} />
										</Grid>
									</Grid>
								</Grid>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button
					variant="contained"
					onClick={onCreateHandler}
					disabled={hasError}
				>
					{isUpdate ? 'Update' : 'Create'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddFlashSale;
